// queryClient — the single TanStack Query client used by the panel.
//
// Lives in its own module (rather than main.tsx) so the apiClient response
// interceptor can import it without creating a circular import via the
// router → page → api → client.ts chain.
//
// Tuned for an authed admin panel: don't burn requests retrying 401/403 —
// the ApiClient interceptor handles refresh + retry separately.
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error: unknown) => {
        const status =
          (error as { response?: { status?: number } })?.response?.status;
        if (status === 401 || status === 403) return false;
        return failureCount < 2;
      },
      staleTime: 30_000,
      refetchOnWindowFocus: false,
    },
  },
});
